import { type ComponentProps, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { fieldVariants } from './fieldStyles';
import { IconEye, IconLock } from './icons';

export type PasswordInputProps = Omit<ComponentProps<'input'>, 'type' | 'size'>;

/** Пароль «с показом» (ACC 4.7.1): кнопка переключает видимость, доступное имя — через t(). */
export function PasswordInput({ className, disabled, ...props }: PasswordInputProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        type={visible ? 'text' : 'password'}
        className={cn(fieldVariants({ size: 'md' }), 'pr-40', className)}
        disabled={disabled}
        {...props}
      />
      <button
        type="button"
        className="absolute top-3 right-3 flex size-28 cursor-pointer items-center justify-center rounded-14 text-ink-500 transition-colors duration-(--duration-fast) hover:bg-surface-sunken hover:text-ink-900 disabled:cursor-not-allowed"
        onClick={() => setVisible((value) => !value)}
        aria-label={visible ? t('actions.hidePassword') : t('actions.showPassword')}
        aria-pressed={visible}
        disabled={disabled}
      >
        {visible ? <IconLock size={16} /> : <IconEye size={16} />}
      </button>
    </div>
  );
}
